import { COLORS } from '@constants/colors';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';
import { isMobileOnly } from 'react-device-detect';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    scrollable: {
      height: 545,
      maxHeight: 'calc(100vh - 376px)',

      [breakpoints.down(ScreenSizes.PcWide)]: {
        maxHeight: 'calc(100dvh - 376px)',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: isMobileOnly ? 'calc(100dvh - 184px)' : 'calc(100vh - 268px)',
        maxHeight: isMobileOnly
          ? 'calc(100dvh - 184px)'
          : 'calc(100dvh - 226px)',
      },
    },
    empty: {
      textAlign: 'center',
      color: COLORS.WHITE,
      pt: 1,
      fontSize: '14px',
    },
  };
};
